import { Button } from '@/components/ui/button';
import { Palette } from 'lucide-react';
import { useBrandTheme } from '@/hooks/use-brand-theme';

export function BrandThemeToggle() {
  const { brand, setBrand } = useBrandTheme();
  const toggle = () => setBrand(brand === 'blue' ? 'orange' : 'blue');
  return (
    <Button variant="ghost" size="icon" onClick={toggle} aria-label={`Switch to ${brand === 'blue' ? 'orange' : 'blue'} theme`}>
      <Palette className="h-[1.2rem] w-[1.2rem]" />
      <span className="sr-only">Switch to {brand === 'blue' ? 'orange' : 'blue'} theme</span>
    </Button>
  );
}
